import e from '@rsbuild/core/compiled/cors';
import { Form } from 'react-bootstrap';

const EndRepeatSelector = ({ endRepeat, setEndRepeat }) => {
  // const handleEndRepeatChange = (e) => {
  //   const value = e.target.value;
  //   setEndRepeat(value);
  //   if (R) {
  //     const options = {
  //       ...R.options,
  //       ...bypassOptions,
  //     };
  //     if (value === 'never') {
  //       options.count = null;
  //       options.until = null;
  //     } else if (value === 'date') {
  //       // For simplicity, set until to 1 year from now
  //       const untilDate = new Date(endDate || Date.now());
  //       if (!endDate) {
  //         untilDate.setFullYear(untilDate.getFullYear() + 1);
  //       }
  //       options.until = untilDate;
  //       options.count = null;
  //     }
  //     const updatedRule = new R.constructor(options);
  //     updateRule(updatedRule);
  //   }
  // };
  return (
    <div className="d-flex justify-content-between align-items-center mb-2">
      <Form.Label htmlFor="end-repeat-select" className="fw-bold text-white mb-1 mb-0">
        End Repeat
      </Form.Label>
      <Form.Select
        id="end-repeat-select"
        value={endRepeat}
        onChange={(e) => setEndRepeat(e.target.value)}
        className="bg-dark text-white border-secondary w-auto"
        style={{ minWidth: 180 }}
      >
        <option value="never">Never</option>
        <option value="date">On Date</option>
      </Form.Select>
    </div>
  );
};

export default EndRepeatSelector;
